  <template>

    <div class="page">
    		<div class="gridheader">
    			<div class="row wrapper">
    				<div class="col-md-4 title"><h1>{{$t('EMPLOYEES')}}</h1></div>
    				<div class="col-md-4">
    					<form method="get" action="">
    						<div class="input-group">
    							<input type="text" v-model="pagination.query" class="form-control" v-bind:placeholder="$t('SEARCHEMPLOYEES')">
                  <div v-if="pagination.query == ''" class="input-group-addon"><img src="../assets/img/icon-search.svg" alt=""></div>
                  <div v-if="pagination.query != ''" v-on:click="pagination.query = ''" class="input-group-addon"><img class="emptysearch" src="../assets/img/icon-close.svg" alt=""></div>
    						</div>
    					</form>
    				</div>
    				<div class="col-md-4 action"><a v-on:click="newEmployee" class="btn btn-primary"><img src="../assets/img/user-plus.svg" alt=""> {{$t('ADDEMPLOYEE')}}</a></div>
    			</div>
    		</div>
        <div class="row" v-if="employees.root.length == 0">
          <div class="col-12 center nothing">
            <img src="../assets/img/icon-novi-nalog-large.svg" alt="">
            <p>{{$t('CURRENTLYNOEMPLOYEES')}}</p>
            <a v-b-modal.newemployee class="btn btn-primary"><img src="../assets/img/user-plus.svg" alt=""> {{$t('ADDEMPLOYEE')}}</a>
          </div>
        </div>
    		<div class="row" v-if="employees.root.length > 0">
          <div class="table-responsive">
      			<table class="maintable">
      				<thead>
      					<tr>
                  <td>{{$t('USERNAME')}}</td>
      						<td>{{$t('NAME')}}</td>
      						<td>{{$t('SURNAME')}}</td>
      						<td>{{$t('GROUPNAME')}}</td>
      						<td>{{$t('DATEENTERED')}}</td>
      						<td>{{$t('STATUS')}}</td>
                  <td>{{$t('ACTIONS')}}</td>
      					</tr>
      				</thead>
      				<tbody>
      					<tr v-for="employee in employees.root">
                  <td><b>{{employee.username}}</b></td>
      						<td><b>{{employee.name}}</b></td>
      						<td><b>{{employee.surname}}</b></td>
      						<td>{{employee.groupName}}</td>
      						<td>{{employee.dateEntered}}</td>
      						<td class="status" v-bind:class="employee.status">{{employee.statusOut}}</td>
                  <td><a href="#" class="grid-action" v-on:click.prevent="deleteEmployee(employee.userId)"><img src="../assets/img/icon-trash.svg" alt=""></a><a href="#" class="grid-action" v-on:click.prevent="editEmployee(employee)"><img src="../assets/img/cell-edit.svg" alt=""></a></td>
      					</tr>
      				</tbody>
      			</table>
          </div>
    		</div>

        <b-pagination v-if="employees.totalCount > 20" align="center" :total-rows="parseInt(employees.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>

        <b-modal size="lg" centered ref="newemployee" id="newemployee" v-bind:ok-title="$t('SAVE')" v-bind:cancel-title="$t('CANCEL')" v-on:ok="saveEmployee" v-bind:title="$t('NEWEMPLOYEE')">
      			<employee-form v-bind:formData="formData" v-bind:formError="formError" v-bind:simple="false"></employee-form>
        </b-modal>

    	</div>



  </template>

  <script>

  import { mapActions, mapGetters } from 'vuex'
  import employeesApi from '@/api/employees'
  import EmployeeForm from '@/components/EmployeeForm.vue'

  export default {
    name: 'Employees',
    components:
    {
      'employee-form': EmployeeForm
    },
    data: function()
    {
      return {
        employees: {root: [], totalCount: 0},
        formData: {
          id: '',
          name: '',
          surname: '',
          userEmail: '',
          username: '',
          password: '',
          userGroup: '',
          status: 'active'
        },
        formError: {},
        pagination:
        {
          query: '',
          currentPage: 1,
          limit: 20
        }
      };
    },
    created: function()
    {
      var me = this;
      me.getEmployees();
    },
    methods:
    {
      newEmployee()
      {
        var me = this;
        me.clearEmployee();
        me.$refs.newemployee.show()
      },
      clearEmployee()
      {
        var me = this;
        me.formData = {
          id: '',
          name: '',
          surname: '',
          userEmail: '',
          username: '',
          password: '',
          userGroup: '',
          status: 'active'
        };
      },
      saveEmployee: function(bvEvt)
      {
        var me = this;

        bvEvt.preventDefault();

        employeesApi.saveEmployee(me.formData, function(val)
        {
          if(val.error)
          {
            me.formError = val;
          }
          else
          {
            me.formError = {};
            me.formData = {
              id: '',
              name: '',
              surname: '',
              userEmail: '',
              username: '',
              password: '',
              userGroup: '',
              status: 'active'
            };
            me.$refs.newemployee.hide()
            me.getEmployees();
          }
        })
      },
      getEmployees: function()
      {
        var me = this;
        employeesApi.getEmployees(me.getParams, function(data)
        {
          if(data.error && data.error == true)
          {
            Vue.$notify.error(data.notice);
            return;
          }
          me.employees = data;
        });
      },
      deleteEmployee: function(id)
      {
        var me = this;
        me.$store.commit('setModalAlert',
        {
          text: me.$i18n.t('AREYOUSHURE'),
          btnAction: function()
          {
            employeesApi.deleteEmployee({id: id}, function(data)
            {
              if(data.error && data.error == true) me.$notify.error(data.notice);
              else me.$notify.success(data.notice);
              me.getEmployees();
            })
          }
        })
      },
      editEmployee: function(data)
      {
        var me = this;
        data = Object.assign({}, data, {});
        data.id = data.userId;
        me.formData = data;
        me.$refs.newemployee.show()
      }
    },
    watch:
    {
      'pagination.currentPage': function(val)
      {
        var me = this;
        me.getEmployees();
      }
    },
    computed:
    {
      getParams: function()
      {
        var me = this;
        var data = Object.assign({}, me.pagination, {});
        data.start = (data.currentPage-1)*data.limit;
        return data;
      }
    }
  }
  </script>



// WEBPACK FOOTER //
// src/components/Employees.vue